
import {defineComponent} from "vue";
import CbFormTextWithImage from "@/components/layouts/content-blocks/forms/CbFormTextWithImage.vue";
import {PageDetailModeEnum} from "@/models/enum/PageDetailModeEnum";

export default defineComponent({
  name: "CategoriesContentBlock",
  computed: {
    PageDetailModeEnum() {
      return PageDetailModeEnum
    }
  },
  components: {CbFormTextWithImage},
});
